import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import FormatListNumberedOutlinedIcon from '@mui/icons-material/FormatListNumberedOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import logo from '../../../assets/230616_RV_logo_restrito_negativo-branco.png';

import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import SignalCellularAltOutlinedIcon from '@mui/icons-material/SignalCellularAltOutlined';
import ImportContactsOutlinedIcon from '@mui/icons-material/ImportContactsOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import './Sidebar.css';
import { useSimulado } from '../../../context/SimuladoContext';

function Sidebar() {
  const { enableFlags } = useSimulado();
  const rankingEnable = enableFlags.rankingEnable;
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

    const handleLogout = () => {
      fetch('https://rvensino.com.br/get.php?action=logout').finally(() => {
        localStorage.clear();
        navigate('/login');
      });
    };

  return (
    <div className="sidebar">
      <div className='sidebar-content'>
        <ul>
            <li>
            <Link to="/">
              <img src="https://rveducacao.com.br/230616_RV_logo_restrito_negativo-branco.png" alt="Logo" className='logo-image' />
            </Link>              
            </li>

              <li className={currentPath === '/dashboard' ? 'active' : ''}>
                <Link to="/dashboard">
                    <DescriptionOutlinedIcon style={{ color: '#fff', fontSize: 45 }} className='sidebar-icon' />
                </Link>
            </li>

            {/* {!firstAccess && (
            )} */}

                <li className={currentPath === '/historico' ? 'active' : ''}>
                  <Link to="/historico">
                  <SignalCellularAltOutlinedIcon style={{ color: '#fff', fontSize: 40 }} className='sidebar-icon' />
                  </Link>
                </li>


            {/* {!firstAccess && (
            )} */}

          

            {/*{rankingEnable && (
            )}
            */}

            <li className={`${!rankingEnable ? 'ranking-disabled' : ''} ${currentPath === '/ranking' ? 'active' : ''}`}>
              <Link to="/ranking">
                <EmojiEventsOutlinedIcon style={{ color: '#fff', fontSize: 40 }} className='sidebar-icon' />
              </Link>
            </li>

          <li className={currentPath === '/disciplinas' ? 'active' : ''}>
            <Link to="/disciplinas">
            <ImportContactsOutlinedIcon style={{ color: '#fff', fontSize: 40 }} className='sidebar-icon' />
            </Link>
          </li>

          <li className={currentPath === '/exam-subscription' ? 'active' : ''}>
            <Link to="/exam-subscription">
            <EditOutlinedIcon style={{ color: '#fff', fontSize: 40 }} className='sidebar-icon' />
            </Link>
          </li>

          
          <li className={currentPath === '/' ? 'active' : ''}>
            <Link to="/">
            <PersonOutlineOutlinedIcon style={{ color: '#fff', fontSize: 40 }} className='sidebar-icon' />
            </Link>
          </li>

          <li className="icon-group">
            <a href="https://ead.rvensino.com.br/" target="_blank" rel="noopener noreferrer">
                <ArrowOutwardIcon style={{ color: '#fff', fontSize: 45 }} className='sidebar-icon'/>
            </a>
            <div onClick={handleLogout} className="logout-wrapper">
                <Link to="/login" className='logout'>
                    <LogoutOutlinedIcon style={{ color: '#fff', fontSize: 45 }} className='logout-icon'/>
                </Link>
            </div>
          </li>

        </ul>
      </div>
    </div>
  );
}

export default Sidebar;
